import { useMemo } from 'react';
import { appcues } from "./appcues";
import { useGtm } from "./gtm";
import { heap } from "./heap";
import { hubspot } from "./hubspot";
export default function useEventTargets() {
  const gtm = useGtm();
  return useMemo(() => ({
    appcues,
    heap,
    hubspot,
    gtm
  }), []);
}
export function getMockEventTargets() {
  return {
    appcues: {
      identify: () => {},
      sendEventDeprecated: () => {},
      report: () => {},
      sendPageView: () => {}
    },
    heap: {
      resetIdentity: () => {},
      identify: () => {},
      sendEventDeprecated: () => {},
      report: () => {}
    },
    hubspot: {
      resetIdentity: () => {},
      identify: () => {},
      sendEventDeprecated: () => {},
      report: () => {},
      sendPageView: () => {}
    },
    gtm: {
      sendEventDeprecated: () => {},
      report: () => {},
      sendPageView: () => {}
    }
  };
}